import { useContext } from 'react';
import { AdvancedFiltersContext } from './AdvancedFiltersContext';

/**
 * A hook to retrieve advancedFilters information.
 */
export const useAdvancedFilters = () => useContext(AdvancedFiltersContext);
